import {useRef} from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {ContactPageFragment as Contact} from 'nutshell-graphql-types';

import {useCoreEntityWorkspaceSidebarCollapsed} from '../../../core-entity/hooks/use-core-entity-workspace-sidebar-collapsed';
import {CoreEntityContent} from '../../../core-entity/layout/core-entity-content';

import {ContactHeaderMiniOnScroll} from '../header-fixed/contact-header-mini-on-scroll';

import {ContactActionBar} from './action-bar/contact-action-bar';
import {WorkspaceSection} from './workspace-section/workspace-section';

type Props = {
    contact: Contact;
    scrollContainerRef: HTMLDivElement | null | undefined;
    user: User;
    hasScrolledPastCheckpoint: boolean;
    getActionBarRef: (ref: HTMLDivElement | null) => void;
    isSidebarCollapsed: boolean;
    scrollContainerTop: number;
    onUpdateAssignee: (assigneeId: string | null) => Promise<any>;
    onUpdateDeletedStatus: (isDeleted: boolean) => Promise<any>;
    onHardDelete: () => Promise<any>;
    hasFullHeightSidebar?: boolean;
};

export function ContactContent(props: Props) {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const {isWorkspaceSidebarCollapsed, handleModeChange} = useCoreEntityWorkspaceSidebarCollapsed(
        props.isSidebarCollapsed,
        'contact'
    );

    return (
        <CoreEntityContent
            contentRef={contentRef}
            hasFullHeightSidebar={props.hasFullHeightSidebar}
        >
            <ContactHeaderMiniOnScroll
                scrollContainerTop={props.scrollContainerTop}
                isShown={props.hasScrolledPastCheckpoint}
                contentRef={contentRef}
                contact={props.contact}
                user={props.user}
                onUpdateAssignee={props.onUpdateAssignee}
                onUpdateDeletedStatus={props.onUpdateDeletedStatus}
                onHardDelete={props.onHardDelete}
            />
            <ContactActionBar
                contact={props.contact}
                user={props.user}
                getRef={props.getActionBarRef}
                hasScrolledPastCheckpoint={props.hasScrolledPastCheckpoint}
            />
            <WorkspaceSection
                contact={props.contact}
                scrollContainerRef={props.scrollContainerRef}
                isSidebarCollapsed={props.isSidebarCollapsed}
                isWorkspaceSidebarCollapsed={isWorkspaceSidebarCollapsed}
                onIsWorkspaceSidebarCollapsedChange={handleModeChange}
                user={props.user}
                hasFullHeightSidebar={props.hasFullHeightSidebar}
            />
        </CoreEntityContent>
    );
}
